import { useFormField as originalUseFormField } from '@nuxt/ui/composables/useFormField';
import { inject, provide } from 'vue';
import { formFieldInjectionKey } from '#ui/composables/useFormField';

type Props<T> = Parameters<typeof originalUseFormField<T>>[0];
type Opts = Parameters<typeof originalUseFormField>[1];

/**
 * Wrapper around NuxtUI `useFormField` that allows forwarding the form field context.
 *
 * Normally NuxtUI clears the form field injection, to prevent duplicate emits in nested form
 * field scenarios. When overriding NuxtUI components with custom wrappers that need access to
 * the form field context, without clearing it, you can pass `forwardContext: true` to re-inject
 * the context and behave transparently.
 */
export function useFormField<T>(props?: Props<T>, opts?: Opts & { forwardContext?: boolean }) {
	const formField = inject(formFieldInjectionKey);
	const result = originalUseFormField(props, opts);

	if (opts?.forwardContext) {
		provide(formFieldInjectionKey, formField);
	}

	return result;
}
